import React, { useState, useEffect } from 'react';
import { useProvider } from '../../context/MenuProvider'; // Importa o contexto do Menu

const OnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);
  const { crudCliente } = useProvider();
  const { error } = crudCliente || {};
  
  const updateOnlineStatus = () => {
    if (error && error?.name === 'CanceledError'){
      setIsOnline(true);
    }else if (error && !error?.response) {
      setIsOnline(false);
    }else{
      setIsOnline(true);
    }
  }

  useEffect(() => {
    // Adiciona os event listeners
    window.addEventListener('online', updateOnlineStatus());
    window.addEventListener('offline', updateOnlineStatus());

    // Remove os event listeners ao desmontar o componente
    return () => {
      window.removeEventListener('online', updateOnlineStatus());
      window.removeEventListener('offline', updateOnlineStatus());
    };
  }, [error]); // Remove a dependência do `isOnline`

  return (
    <div className="text-center">
      {window.navigator.onLine 
        ? !isOnline && <div className="text-danger fs-5">Sem conexão com o servidor!</div>
        : <div className="text-danger fs-5">Sem conexão com a internet!</div>
      }
    </div>
  );
}

export default OnlineStatus;